<section
  class="md:px-3 lg:px-6 flex justify-center bg-gradient-to-b from-[#7B8693] to-[#DDE2E7] pt-28 pb-28 max-md:px-2 max-lg:pb-14">
  <div class="flex max-w-[1330px] w-full justify-between max-lg:flex-col gap-4">
    <div class="w-1/2 flex flex-col gap-24 max-lg:w-full">
      <div class="">
        <h1 class="font-bold max-md:text-6xl text-8xl flex font-tektur mb-2.5" i18n>
          DONATE CAR TO UKRAINE
        </h1>
        <h3 class="font-tektur flex text-mainColor text-xl lg:w-[88%]" i18n>
          Dozens of people across EU, UK and the US have
          donated their cars or sold them to buy cars Ukrainian
          soldiers need right now.
        </h3>
      </div>
      <div class="flex w-full gap-6 max-lg:flex-col max-lg:mb-5">
        <div (click)="selectOption('0')"
             class="primary-button w-[286px] h-[70px] px-[18px] bg-[#1f2024] justify-center items-center gap-[7px] inline-flex max-lg:w-full cursor-pointer">
          <div
            class="text-center text-[#f7f8f7] text-2xl font-medium font-tektur leading-loose tracking-[2.88px]" i18n>
            BUY CAR
          </div>
        </div>
        <div (click)="selectOption('1')"
             class="w-[254px] h-[70px] px-[18px] secondary-button border-2 border-[#1f2024] justify-center items-center gap-[7px] inline-flex max-lg:w-full">
          <div
            class="text-center text-2xl font-medium leading-loose tracking-[2.88px]">
            DONATE CAR
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-1 flex-col overflow-hidden w-full max-lg:hidden">
<!--      [width]="playerWidth()"
        [height]="playerHeight()"-->
      <youtube-player
        class="[&>.youtube-player-placeholder]:aspect-[16/9] [&>.youtube-player-placeholder]:!w-full [&>.youtube-player-placeholder]:!h-full"
        [videoId]="articles[0].videoId"

      />
      <div class="font-tektur text-base text-mainColor tracking-wider mt-2">
        Wheels Of War: The Road to Ukraine. A group of enthusiasts from the UK and Ireland wanted to donate cars to Ukraine army and made all the way from Britain to Lviv
      </div>
    </div>
  </div>
</section>

<section class="bg-[#1F2125] flex justify-center py-28 max-lg:px-2.5 max-lg:py-14">
  <div class="flex max-w-[1330px] w-full justify-center flex-wrap items-center md:px-3 lg:px-6">
    <div class="w-full">
      <h1 class="font-bold text-[58px] flex font-tektur mb-2.5 text-[#DDE2E7] max-lg:text-4xl" i18n>
        The Road to Ukraine
      </h1>
      <h3 class="font-tektur flex text-[#919EAB] text-xl" i18n>
        Dozens of people across EU, UK and the US have <br>
        donated their cars or sold them to buy cars Ukrainian <br>
        soldiers need right now.
      </h3>
    </div>
    <div class="w-full">
      <div class="col-span-12">
        <div class="relative flex w-full overflow-x-auto scrollbar-hide gap-6 my-4 py-4" #scrollContainer>
          @for (article of articles; track article.videoId) {
            <div class="min-w-[300px] flex-shrink-0 rounded-lg p-4">
              <div class="grid grid-cols-12 min-h-[300px]">
                <div class="col-span-12 flex flex-col justify-between">
                  @if (article.videoId) {
                    <youtube-player
                      [videoId]="article.videoId"
                      [width]="playerWidth()"
                      [height]="playerHeight()"
                    />
                  } @else {
                    <a [href]="article.href" target="_blank" class="max-w-[600px]">
                      <img
                        class="mb-4 rounded-lg max-w-[600px] text-[#919EAB] min-h-[390px] max-h-[390px]"
                        [src]="assetsPath + article.image"
                        [title]="article.title"
                        [alt]="article.title"
                      />
                    </a>
                  }
                  <div
                    class=" flex max-w-[600px] max-lg:max-w-[400px] text-base font-tektur text-[#919EAB] mt-2 line-clamp-3"
                    [innerHTML]="article.details"></div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="col-span-12 mt-5">
        <div class="justify-start items-center gap-[27px] flex max-lg:flex-col max-lg:items-start">
          <div class="justify-start items-center flex gap-8 lg:w-[21%]">
            <div
              (click)="prevSlide()"
              class="w-[55px] h-[55px] cursor-pointer flex justify-center items-center border border-[#dde1e6] "
            >
              <ng-icon class="text-white" name="heroArrowLeft"></ng-icon>
            </div>
            <div
              class="text-[#dde1e6] text-base font-normal font-['Tektur'] leading-[23px] tracking-wide"
            >
              {{ currentSlideIndex + 1 }} / {{ articles.length }}
            </div>
            <div
              (click)="nextSlide()"
              class="w-[55px] h-[55px] cursor-pointer flex justify-center items-center border border-[#dde1e6] "
            >
              <ng-icon class="text-white" name="heroArrowRight"></ng-icon>
            </div>
          </div>
          <div class="w-full h-[3px] relative">
            <div
              class="w-full h-0.5 left-0 top-[1px] absolute opacity-60 bg-[#8895a4]"
            ></div>
            <div
              class="w-[10%] h-[3px] left-0 top-0 absolute bg-[#dde1e6]"
              [style.left]="getProgressPosition()"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="bg-white flex justify-center py-28 max-lg:px-2.5 max-lg:py-14">
  <div class="flex max-w-[1330px] max-[1330px]:px-10 w-full flex-wrap">
    <div>
      <p class="font-tektur text-mainColor text-[58px] font-bold max-lg:text-4xl mb-2.5" i18n>Welcome to Ukraine</p>
      <p class="font-tektur text-mainColor text-xl lg:max-w-lg" i18n>
        People who decide to donate a car and bring it to Ukraine not only provide a very tangible donation knowing exactly where and how the truck is used, but also get a unique opportunity to meet with our team, spend some time in a gorgeous city of Lviv, followed by a dinner with some local beer 🙂
      </p>
    </div>
    <div>
      <img ngSrc="assets/images/group.webp" alt="group" height="616" width="1328">
    </div>
  </div>
</section>
<section class="bg-[#F4F5F6] flex justify-center py-28 max-lg:py-14">
  <div class="flex max-w-[1330px] w-full justify-center gap-10 max-[1330px]:px-10 max-lg:flex-col">
    <div class="bg-[#F4F5F6] w-full">
      <h2 class="font-tektur text-mainColor text-6xl font-bold mb-2 max-lg:text-4xl" i18n>
        Want to Donate Car to Ukraine?
      </h2>
      <p class="font-tektur text-xl mb-6 text-mainColor" i18n>
        Fill up the form, and we’ll get back to you within 24 hours
      </p>

      <form [formGroup]="donateForm" (ngSubmit)="submitForm()" class="space-y-4" #donationForm>
        <!-- Radio Buttons -->
        <div>
          <label class="block text-sm uppercase text-mainColor font-medium mb-2 font-tektur" i18n>
            How would you like to help?
          </label>
          <div class="flex gap-2 justify-between max-lg:flex-col">
            <label class="flex flex-1 justify-center items-center bg-[#2452DD] py-3.5 cursor-pointer max-lg:pl-3"
                   [ngClass]="getHelpTypeClass('buyCar')">
              <input
                type="radio"
                formControlName="helpType"
                value="0"
                class="form-radio  border-[#919EAB]"
              />
              <span class="ml-2  text-base font-tektur" i18n>Buy a car</span>
            </label>

            <label class="flex items-center py-3.5 justify-center flex-1 cursor-pointer max-lg:pl-3"
                   [ngClass]="getHelpTypeClass('donateCar')">
              <input
                type="radio"
                formControlName="helpType"
                value="1"
                class="form-radio"
              />
              <span class="ml-2 font-tektur" i18n>Donate a car</span>
            </label>

            <label class="flex items-center py-3.5 justify-center flex-1 cursor-pointer max-lg:pl-3"
                   [ngClass]="getHelpTypeClass('sellDiscountCar')">
              <input
                type="radio"
                formControlName="helpType"
                value="2"
                class="form-radio"
              />
              <span class="ml-2 font-tektur" i18n>Sell a car with discount</span>
            </label>
          </div>
        </div>

        <!-- Name -->
        <div class="flex-col gap-4">
          <div [ngClass]="{'has-error': donateForm.get('name')?.invalid && donateForm.get('name')?.touched}"
               class="relative mb-6">
            <label for="name" class="block text-gray-700 font-medium mb-2 font-tektur" i18n>
              Your Name
            </label>
            <input
              id="name"
              type="text"
              formControlName="name"
              [placeholder]="'Type'"
              class="bg-transparent mt-0 block w-full px-0.5 border-0 border-b-2 border-[#8996A5] focus:ring-0 focus:border-black font-tektur placeholder:text-[#7B8693]"
            />
            @if (donateForm.get('name')?.invalid && donateForm.get('name')?.touched) {
              <div class="error-message text-rose-600 font-tektur absolute" i18n>
                Name is required.
              </div>
            }
          </div>

          <!-- Email -->
          <div [ngClass]="{'has-error': donateForm.get('email')?.invalid && donateForm.get('email')?.touched}"
               class="mb-6">
            <label for="email" class="block text-gray-700 font-medium mb-2 font-tektur" i18n>
              Email
            </label>
            <input
              id="email"
              type="email"
              formControlName="email"
              [placeholder]="'Type'"
              class="bg-transparent mt-0 block w-full px-0.5 border-0 border-b-2 border-[#8996A5] focus:ring-0 focus:border-black font-tektur placeholder:text-[#7B8693]"
            />
            @if (donateForm.get('email')?.invalid && donateForm.get('email')?.touched) {
              <div class="error-message text-rose-600 font-tektur absolute" i18n>
                Name is required.
              </div>
            }
          </div>

          <!-- Message -->
          <div [ngClass]="{'has-error': donateForm.get('message')?.invalid && donateForm.get('message')?.touched}"
               class="mb-6">
            <label for="message" class="block font-medium mb-2 font-tektur" i18n>
              Message
            </label>
            <textarea
              id="message"
              formControlName="message"
              [placeholder]="'Type'"
              rows="3"
              class="relative bg-transparent mt-0 block w-full px-0.5 border-0 border-b-2 border-[#8996A5] focus:ring-0 focus:border-black font-tektur placeholder:text-[#7B8693]"
            ></textarea>
            @if (donateForm.get('message')?.invalid && donateForm.get('message')?.touched) {
              <div class="error-message text-rose-600 font-tektur absolute" i18n>
                Name is required.
              </div>
            }
          </div>

          <!-- Submit Button -->

          <button
            type="submit"
            unselectable="on"
            onselectstart="return false;"
            onmousedown="return false;"
            [class.bg-green-100]="showSuccessAlert"
            [class.bg-[#1f2024]]="!showSuccessAlert"
            class="noselect primary-button w-full h-[69px] px-[18px] justify-center items-center gap-[7px] inline-flex transition-all
                 duration-150 ease-in-out active:scale-95 cursor-pointer mt-5"
          >
            <div
              class="send-button text-center text-[#f7f8f7] text-2xl font-medium font-['Tektur'] leading-loose
                         tracking-[2.88px] transition-all duration-150 ease-in-out active:scale-95 active:shadow-lg"
            >


              @if (showSuccessAlert) {

                <div class="text-green-700 flex gap-4 justify-center items-center">
                  <span>Success!</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-send-check" viewBox="0 0 16 16">
                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855a.75.75 0 0 0-.124 1.329l4.995 3.178 1.531 2.406a.5.5 0 0 0 .844-.536L6.637 10.07l7.494-7.494-1.895 4.738a.5.5 0 1 0 .928.372zm-2.54 1.183L5.93 9.363 1.591 6.602z"/>
                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686"/>
                  </svg>
                </div>

              } @else {

                @if (pending) {

                  <div class="animate-spin">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor"
                         class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                      <path
                        d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                      <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
                    </svg>
                  </div>

                } @else {
                  <span class="cursor-pointer font-tektur" i18n>
                    SEND MESSAGE
                  </span>

                }

              }

            </div>
          </button>
        </div>
      </form>
    </div>
    <div class="flex w-1/2 justify-center lg:justify-end items-end max-lg:px-2.5 max-lg:w-full">
      <div
        class="bg-white max-w-[437px] w-full h-full max-h-[561px] flex justify-center flex-col items-center rounded-md p-5">
        <img class="max-w-[214px]  max-h-[214px] mb-5" src="assets/images/profile.png" alt="profile">
        <p class="text-xl font-tektur text-mainColor">Ivan Oleksii</p>
        <span class="text-base font-tektur text-[#919EAB] mb-10">Co-creator of Car for Ukraine</span>
        <span class="font-tektur text-mainColor" i18n>
          Do you have a car to donate, or are you interested in buying one for the Ukrainian army?
          Please share the details with us, and we'll get back to you within 24 hours!
        </span>
      </div>
    </div>
  </div>
</section>
<app-faq-section></app-faq-section>
